import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportContentsRoutingModule } from './report-contents-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReportContentListComponent } from './report-content-list/report-content-list.component';
import { ReportContentDetailsComponent } from './report-content-details/report-content-details.component';

@NgModule({
  declarations: [
    ReportContentListComponent,
    ReportContentDetailsComponent
  ],
  imports: [CommonModule, ReportContentsRoutingModule, SharedModule],
})
export class ReportContentsModule {}
